import { Component, factory } from '../compiler';

export function loadComponents(...components: any[]): void {
	const run = () => factory(components)(document.body);

	if (document.readyState === 'loading') {
		const handler = () => {
			document.removeEventListener('DOMContentLoaded', handler);
			run();
		};
		document.addEventListener('DOMContentLoaded', handler);
	} else {
		run();
	}
}

export function createDefaultComponent(
	component: any,
	className: string,
	observe = true
) {
	const cls = class componentClass {
		constructor(element: HTMLElement) {
			new component(element);
		}
	};

	const annotated = Component({ className, observe })(cls);

	return annotated;
}
